import { toast } from "react-toastify";
import * as requestFromServer from "./LandingPageCrud";
import { callTypes, LandingPageSlice } from "./LandingPageSlice";
const { actions } = LandingPageSlice;

export const savePost =
  (details, setSuccessScreen, setDisabled) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer
      .savePostCrud(details)
      .then((response) => {
        const { data } = response;
        toast.success("आपकी रचना सफलतापूर्वक सबमिट हो गई है", {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        if (setDisabled) {
          setDisabled(false);
        }
        dispatch(actions.postSaved({ data }));
        setSuccessScreen(true);
      })
      .catch((error) => {
        let duplicatePostError = false;
        if (error && error.response && error.response.data) {
          //console.log(error && error.response && error.response.data);
          let data = error.response.data;
          if (data.duplicate === true) {
            duplicatePostError = true;
          }
        }
        if (duplicatePostError) {
          error.clientMessage =
            "इस ईमेल द्वारा पोस्ट पहले ही सबमिट कर दी गई है।";

          toast.error(error.clientMessage, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });

          dispatch(actions.catchError({ error, callType: callTypes.list }));
        } else {
          error.clientMessage = "सहेजने में विफल है. कृपया पुन: प्रयास करें।";
          toast.error(error.clientMessage, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });

          dispatch(actions.catchError({ error, callType: callTypes.list }));
        }
        if (setDisabled) {
          setDisabled(false);
        }
        setSuccessScreen(false);
      });
  };
